/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivityDocumentResponseDto } from '../models';
// @ts-ignore
import type { ActivityDocumentsResponseDto } from '../models';
// @ts-ignore
import type { CreateProfessionalActivityRequestDto } from '../models';
// @ts-ignore
import type { EmployeeProfileRoleDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ProfessionalActivitiesResponseDto } from '../models';
// @ts-ignore
import type { ProfessionalActivityResponseDto } from '../models';
// @ts-ignore
import type { ToggleAiContextRequestDto } from '../models';
/**
 * ProfessionalActivitiesApi - axios parameter creator
 * @export
 */
export const ProfessionalActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a professional activity (profile owner only)
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {CreateProfessionalActivityRequestDto} createProfessionalActivityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfessionalActivity: async (employeeId: string, role: EmployeeProfileRoleDto, createProfessionalActivityRequestDto: CreateProfessionalActivityRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createProfessionalActivity', 'employeeId', employeeId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('createProfessionalActivity', 'role', role)
            // verify required parameter 'createProfessionalActivityRequestDto' is not null or undefined
            assertParamExists('createProfessionalActivity', 'createProfessionalActivityRequestDto', createProfessionalActivityRequestDto)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProfessionalActivityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Removes the file from S3 and its chunks from the activity vector store.
         * @summary Delete an attached document
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityDocument: async (employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteActivityDocument', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('deleteActivityDocument', 'activityId', activityId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteActivityDocument', 'documentId', documentId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('deleteActivityDocument', 'role', role)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}/documents/{documentId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a professional activity (profile owner only)
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfessionalActivity: async (employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteProfessionalActivity', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('deleteProfessionalActivity', 'activityId', activityId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('deleteProfessionalActivity', 'role', role)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires employees.activities.documents.view for the acting role, plus the view permission matching the activity lifecycle. presignedUrl is returned only when the role also holds employees.activities.documents.download; without it the field is absent and the file cannot be reached.
         * @summary List documents attached to an activity
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityDocuments: async (employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getActivityDocuments', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getActivityDocuments', 'activityId', activityId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getActivityDocuments', 'role', role)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}/documents`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Scoped by the acting role: active items need employees.activities.active.view, archived ones employees.activities.archived.view. Without either permission the call is rejected; with only one of them the other lifecycle is filtered out.
         * @summary List professional activities of the employee
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {boolean} [active] Filter by lifecycle: true &#x3D; active (PLANNED or IN_PROGRESS), false &#x3D; archived (COMPLETED), absent &#x3D; all. Applied before pagination.
         * @param {number} [page] 0-based page number. Pagination activates only when both page and pageSize are provided; otherwise the full sorted list is returned.
         * @param {number} [pageSize] Page size. Required together with page to enable pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivities: async (employeeId: string, role: EmployeeProfileRoleDto, active?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getProfessionalActivities', 'employeeId', employeeId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getProfessionalActivities', 'role', role)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires the acting role to hold the view permission matching the activity lifecycle (active or archived).
         * @summary Get a professional activity by id
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivity: async (employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getProfessionalActivity', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getProfessionalActivity', 'activityId', activityId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getProfessionalActivity', 'role', role)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Clears the document vectors and repeats extraction + embedding asynchronously. Useful after a failed embedding or when the document had no text.
         * @summary Re-extract and re-embed a document
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reembedActivityDocument: async (employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('reembedActivityDocument', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('reembedActivityDocument', 'activityId', activityId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('reembedActivityDocument', 'documentId', documentId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('reembedActivityDocument', 'role', role)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}/documents/{documentId}/reembed`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires employees.activities.documents.manage for the acting role.
         * @summary Toggle whether a document is used as AI chat context
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleActivityDocumentAiContext: async (employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('toggleActivityDocumentAiContext', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('toggleActivityDocumentAiContext', 'activityId', activityId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('toggleActivityDocumentAiContext', 'documentId', documentId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('toggleActivityDocumentAiContext', 'role', role)
            // verify required parameter 'toggleAiContextRequestDto' is not null or undefined
            assertParamExists('toggleActivityDocumentAiContext', 'toggleAiContextRequestDto', toggleAiContextRequestDto)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}/documents/{documentId}/ai-context`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleAiContextRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Per-employee opt-out over an admin definition document. includeInChat=false stores an opt-out; true removes it. The document\'s global ai_context flag still gates eligibility.
         * @summary Include or exclude an admin definition document from this employee\'s chat
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDefinitionDocumentChatInclusion: async (employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('toggleDefinitionDocumentChatInclusion', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('toggleDefinitionDocumentChatInclusion', 'activityId', activityId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('toggleDefinitionDocumentChatInclusion', 'documentId', documentId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('toggleDefinitionDocumentChatInclusion', 'role', role)
            // verify required parameter 'toggleAiContextRequestDto' is not null or undefined
            assertParamExists('toggleDefinitionDocumentChatInclusion', 'toggleAiContextRequestDto', toggleAiContextRequestDto)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}/definition-documents/{documentId}/chat-inclusion`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleAiContextRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. File is stored in S3; text is extracted and embedded asynchronously into the isolated activity vector store.
         * @summary Upload a document and attach it to an activity
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActivityDocument: async (employeeId: string, activityId: number, role: EmployeeProfileRoleDto, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('uploadActivityDocument', 'employeeId', employeeId)
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('uploadActivityDocument', 'activityId', activityId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('uploadActivityDocument', 'role', role)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadActivityDocument', 'file', file)
            const localVarPath = `/api/v1/employees/{employeeId}/professional-activities/{activityId}/documents`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfessionalActivitiesApi - functional programming interface
 * @export
 */
export const ProfessionalActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfessionalActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a professional activity (profile owner only)
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {CreateProfessionalActivityRequestDto} createProfessionalActivityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProfessionalActivity(employeeId: string, role: EmployeeProfileRoleDto, createProfessionalActivityRequestDto: CreateProfessionalActivityRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProfessionalActivity(employeeId, role, createProfessionalActivityRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.createProfessionalActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Removes the file from S3 and its chunks from the activity vector store.
         * @summary Delete an attached document
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivityDocument(employeeId, activityId, documentId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.deleteActivityDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft-delete a professional activity (profile owner only)
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfessionalActivity(employeeId, activityId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.deleteProfessionalActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires employees.activities.documents.view for the acting role, plus the view permission matching the activity lifecycle. presignedUrl is returned only when the role also holds employees.activities.documents.download; without it the field is absent and the file cannot be reached.
         * @summary List documents attached to an activity
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityDocuments(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityDocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityDocuments(employeeId, activityId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.getActivityDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Scoped by the acting role: active items need employees.activities.active.view, archived ones employees.activities.archived.view. Without either permission the call is rejected; with only one of them the other lifecycle is filtered out.
         * @summary List professional activities of the employee
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {boolean} [active] Filter by lifecycle: true &#x3D; active (PLANNED or IN_PROGRESS), false &#x3D; archived (COMPLETED), absent &#x3D; all. Applied before pagination.
         * @param {number} [page] 0-based page number. Pagination activates only when both page and pageSize are provided; otherwise the full sorted list is returned.
         * @param {number} [pageSize] Page size. Required together with page to enable pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfessionalActivities(employeeId: string, role: EmployeeProfileRoleDto, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivitiesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfessionalActivities(employeeId, role, active, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.getProfessionalActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires the acting role to hold the view permission matching the activity lifecycle (active or archived).
         * @summary Get a professional activity by id
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfessionalActivity(employeeId, activityId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.getProfessionalActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Clears the document vectors and repeats extraction + embedding asynchronously. Useful after a failed embedding or when the document had no text.
         * @summary Re-extract and re-embed a document
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reembedActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reembedActivityDocument(employeeId, activityId, documentId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.reembedActivityDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires employees.activities.documents.manage for the acting role.
         * @summary Toggle whether a document is used as AI chat context
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleActivityDocumentAiContext(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleActivityDocumentAiContext(employeeId, activityId, documentId, role, toggleAiContextRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.toggleActivityDocumentAiContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Per-employee opt-out over an admin definition document. includeInChat=false stores an opt-out; true removes it. The document\'s global ai_context flag still gates eligibility.
         * @summary Include or exclude an admin definition document from this employee\'s chat
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleDefinitionDocumentChatInclusion(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleDefinitionDocumentChatInclusion(employeeId, activityId, documentId, role, toggleAiContextRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.toggleDefinitionDocumentChatInclusion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. File is stored in S3; text is extracted and embedded asynchronously into the isolated activity vector store.
         * @summary Upload a document and attach it to an activity
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadActivityDocument(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityDocumentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadActivityDocument(employeeId, activityId, role, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivitiesApi.uploadActivityDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfessionalActivitiesApi - factory interface
 * @export
 */
export const ProfessionalActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfessionalActivitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a professional activity (profile owner only)
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {CreateProfessionalActivityRequestDto} createProfessionalActivityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfessionalActivity(employeeId: string, role: EmployeeProfileRoleDto, createProfessionalActivityRequestDto: CreateProfessionalActivityRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityResponseDto> {
            return localVarFp.createProfessionalActivity(employeeId, role, createProfessionalActivityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Removes the file from S3 and its chunks from the activity vector store.
         * @summary Delete an attached document
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteActivityDocument(employeeId, activityId, documentId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a professional activity (profile owner only)
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProfessionalActivity(employeeId, activityId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires employees.activities.documents.view for the acting role, plus the view permission matching the activity lifecycle. presignedUrl is returned only when the role also holds employees.activities.documents.download; without it the field is absent and the file cannot be reached.
         * @summary List documents attached to an activity
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityDocuments(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<ActivityDocumentsResponseDto> {
            return localVarFp.getActivityDocuments(employeeId, activityId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * Scoped by the acting role: active items need employees.activities.active.view, archived ones employees.activities.archived.view. Without either permission the call is rejected; with only one of them the other lifecycle is filtered out.
         * @summary List professional activities of the employee
         * @param {string} employeeId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {boolean} [active] Filter by lifecycle: true &#x3D; active (PLANNED or IN_PROGRESS), false &#x3D; archived (COMPLETED), absent &#x3D; all. Applied before pagination.
         * @param {number} [page] 0-based page number. Pagination activates only when both page and pageSize are provided; otherwise the full sorted list is returned.
         * @param {number} [pageSize] Page size. Required together with page to enable pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivities(employeeId: string, role: EmployeeProfileRoleDto, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivitiesResponseDto> {
            return localVarFp.getProfessionalActivities(employeeId, role, active, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires the acting role to hold the view permission matching the activity lifecycle (active or archived).
         * @summary Get a professional activity by id
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityResponseDto> {
            return localVarFp.getProfessionalActivity(employeeId, activityId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Clears the document vectors and repeats extraction + embedding asynchronously. Useful after a failed embedding or when the document had no text.
         * @summary Re-extract and re-embed a document
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reembedActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reembedActivityDocument(employeeId, activityId, documentId, role, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires employees.activities.documents.manage for the acting role.
         * @summary Toggle whether a document is used as AI chat context
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleActivityDocumentAiContext(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleActivityDocumentAiContext(employeeId, activityId, documentId, role, toggleAiContextRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. Per-employee opt-out over an admin definition document. includeInChat=false stores an opt-out; true removes it. The document\'s global ai_context flag still gates eligibility.
         * @summary Include or exclude an admin definition document from this employee\'s chat
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {number} documentId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDefinitionDocumentChatInclusion(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleDefinitionDocumentChatInclusion(employeeId, activityId, documentId, role, toggleAiContextRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires employees.activities.documents.manage for the acting role. File is stored in S3; text is extracted and embedded asynchronously into the isolated activity vector store.
         * @summary Upload a document and attach it to an activity
         * @param {string} employeeId 
         * @param {number} activityId 
         * @param {EmployeeProfileRoleDto} role 
         * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActivityDocument(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ActivityDocumentResponseDto> {
            return localVarFp.uploadActivityDocument(employeeId, activityId, role, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfessionalActivitiesApi - interface
 * @export
 * @interface ProfessionalActivitiesApi
 */
export interface ProfessionalActivitiesApiInterface {
    /**
     * 
     * @summary Create a professional activity (profile owner only)
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {CreateProfessionalActivityRequestDto} createProfessionalActivityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    createProfessionalActivity(employeeId: string, role: EmployeeProfileRoleDto, createProfessionalActivityRequestDto: CreateProfessionalActivityRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityResponseDto>;

    /**
     * Requires employees.activities.documents.manage for the acting role. Removes the file from S3 and its chunks from the activity vector store.
     * @summary Delete an attached document
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    deleteActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Soft-delete a professional activity (profile owner only)
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    deleteProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Requires employees.activities.documents.view for the acting role, plus the view permission matching the activity lifecycle. presignedUrl is returned only when the role also holds employees.activities.documents.download; without it the field is absent and the file cannot be reached.
     * @summary List documents attached to an activity
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    getActivityDocuments(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<ActivityDocumentsResponseDto>;

    /**
     * Scoped by the acting role: active items need employees.activities.active.view, archived ones employees.activities.archived.view. Without either permission the call is rejected; with only one of them the other lifecycle is filtered out.
     * @summary List professional activities of the employee
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {boolean} [active] Filter by lifecycle: true &#x3D; active (PLANNED or IN_PROGRESS), false &#x3D; archived (COMPLETED), absent &#x3D; all. Applied before pagination.
     * @param {number} [page] 0-based page number. Pagination activates only when both page and pageSize are provided; otherwise the full sorted list is returned.
     * @param {number} [pageSize] Page size. Required together with page to enable pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    getProfessionalActivities(employeeId: string, role: EmployeeProfileRoleDto, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivitiesResponseDto>;

    /**
     * Requires the acting role to hold the view permission matching the activity lifecycle (active or archived).
     * @summary Get a professional activity by id
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    getProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityResponseDto>;

    /**
     * Requires employees.activities.documents.manage for the acting role. Clears the document vectors and repeats extraction + embedding asynchronously. Useful after a failed embedding or when the document had no text.
     * @summary Re-extract and re-embed a document
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    reembedActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Requires employees.activities.documents.manage for the acting role.
     * @summary Toggle whether a document is used as AI chat context
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    toggleActivityDocumentAiContext(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Requires employees.activities.documents.manage for the acting role. Per-employee opt-out over an admin definition document. includeInChat=false stores an opt-out; true removes it. The document\'s global ai_context flag still gates eligibility.
     * @summary Include or exclude an admin definition document from this employee\'s chat
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    toggleDefinitionDocumentChatInclusion(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Requires employees.activities.documents.manage for the acting role. File is stored in S3; text is extracted and embedded asynchronously into the isolated activity vector store.
     * @summary Upload a document and attach it to an activity
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApiInterface
     */
    uploadActivityDocument(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ActivityDocumentResponseDto>;

}

/**
 * ProfessionalActivitiesApi - object-oriented interface
 * @export
 * @class ProfessionalActivitiesApi
 * @extends {BaseAPI}
 */
export class ProfessionalActivitiesApi extends BaseAPI implements ProfessionalActivitiesApiInterface {
    /**
     * 
     * @summary Create a professional activity (profile owner only)
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {CreateProfessionalActivityRequestDto} createProfessionalActivityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public createProfessionalActivity(employeeId: string, role: EmployeeProfileRoleDto, createProfessionalActivityRequestDto: CreateProfessionalActivityRequestDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).createProfessionalActivity(employeeId, role, createProfessionalActivityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires employees.activities.documents.manage for the acting role. Removes the file from S3 and its chunks from the activity vector store.
     * @summary Delete an attached document
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public deleteActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).deleteActivityDocument(employeeId, activityId, documentId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a professional activity (profile owner only)
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public deleteProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).deleteProfessionalActivity(employeeId, activityId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires employees.activities.documents.view for the acting role, plus the view permission matching the activity lifecycle. presignedUrl is returned only when the role also holds employees.activities.documents.download; without it the field is absent and the file cannot be reached.
     * @summary List documents attached to an activity
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public getActivityDocuments(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).getActivityDocuments(employeeId, activityId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Scoped by the acting role: active items need employees.activities.active.view, archived ones employees.activities.archived.view. Without either permission the call is rejected; with only one of them the other lifecycle is filtered out.
     * @summary List professional activities of the employee
     * @param {string} employeeId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {boolean} [active] Filter by lifecycle: true &#x3D; active (PLANNED or IN_PROGRESS), false &#x3D; archived (COMPLETED), absent &#x3D; all. Applied before pagination.
     * @param {number} [page] 0-based page number. Pagination activates only when both page and pageSize are provided; otherwise the full sorted list is returned.
     * @param {number} [pageSize] Page size. Required together with page to enable pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public getProfessionalActivities(employeeId: string, role: EmployeeProfileRoleDto, active?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).getProfessionalActivities(employeeId, role, active, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires the acting role to hold the view permission matching the activity lifecycle (active or archived).
     * @summary Get a professional activity by id
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public getProfessionalActivity(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).getProfessionalActivity(employeeId, activityId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires employees.activities.documents.manage for the acting role. Clears the document vectors and repeats extraction + embedding asynchronously. Useful after a failed embedding or when the document had no text.
     * @summary Re-extract and re-embed a document
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public reembedActivityDocument(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).reembedActivityDocument(employeeId, activityId, documentId, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires employees.activities.documents.manage for the acting role.
     * @summary Toggle whether a document is used as AI chat context
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public toggleActivityDocumentAiContext(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).toggleActivityDocumentAiContext(employeeId, activityId, documentId, role, toggleAiContextRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires employees.activities.documents.manage for the acting role. Per-employee opt-out over an admin definition document. includeInChat=false stores an opt-out; true removes it. The document\'s global ai_context flag still gates eligibility.
     * @summary Include or exclude an admin definition document from this employee\'s chat
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {number} documentId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {ToggleAiContextRequestDto} toggleAiContextRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public toggleDefinitionDocumentChatInclusion(employeeId: string, activityId: number, documentId: number, role: EmployeeProfileRoleDto, toggleAiContextRequestDto: ToggleAiContextRequestDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).toggleDefinitionDocumentChatInclusion(employeeId, activityId, documentId, role, toggleAiContextRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires employees.activities.documents.manage for the acting role. File is stored in S3; text is extracted and embedded asynchronously into the isolated activity vector store.
     * @summary Upload a document and attach it to an activity
     * @param {string} employeeId 
     * @param {number} activityId 
     * @param {EmployeeProfileRoleDto} role 
     * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivitiesApi
     */
    public uploadActivityDocument(employeeId: string, activityId: number, role: EmployeeProfileRoleDto, file: File, options?: RawAxiosRequestConfig) {
        return ProfessionalActivitiesApiFp(this.configuration).uploadActivityDocument(employeeId, activityId, role, file, options).then((request) => request(this.axios, this.basePath));
    }
}

